import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// project imports
import { AccountInterface, AccountStateInterface } from './accountTypes';
import { EmsMemberAccountInterface } from 'features/eai/eaiTypes';

// ==============================|| ACCOUNT SLICE ||============================== //

const initialState: AccountStateInterface = {
  realm: null,
  tenant: null,
  account: null,
  selectedEmsMemberAccount: null
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setRealm: (state, action: PayloadAction<string | null>) => {
      state.realm = action.payload;
    },
    setTenant: (state, action: PayloadAction<string | null>) => {
      state.tenant = action.payload;
    },
    accountLogin: (state, action: PayloadAction<AccountInterface>) => {
      const { accountInfo, accessToken } = action.payload;

      state.account = { accountInfo, accessToken };
    },
    accountLogout: (state) => {
      state.account = null;
    },
    setSelectedEmsMemberAccount: (
      state,
      action: PayloadAction<EmsMemberAccountInterface | null>
    ) => {
      state.selectedEmsMemberAccount = action.payload;
    }
  }
});

export const {
  accountLogin,
  accountLogout,
  setSelectedEmsMemberAccount,
  setRealm,
  setTenant
} = accountSlice.actions;

export const account = accountSlice.reducer;
